export const githubUsername = "dominikblak";
